import cookie from './cookie';

const loggedIn = cookie.get('loggedIn') === 'true';

export default loggedIn;
